import { useHistory } from "react-router-dom";

import t from "../../../i18n/i18n";

import DefRoutes from "../../../routes/routes.json";

function Auth() {
  const { push } = useHistory();

  return (
    <div className="login-regester-btn">
      <div className="btn-warp">
        <button type="button" className="btn-user" onClick={() => push(DefRoutes.SignIn)}>
          <i className="fal fa-user"></i>
          <span className="title">{t("Menu.SignIn")}</span>
        </button>
      </div>
      <div className="btn-warp">
        <button type="button" className="btn-user" onClick={() => push(DefRoutes.SignUp)}>
          <i className="fas fa-check-circle"></i>
          <span className="title">{t("Menu.SignUp")}</span>
        </button>
      </div>
    </div>
  );
}

export default Auth;
